import axios from 'axios'

const api = axios.create({
    baseURL: import.meta.env.PUBLIC_API_URL,
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
})

let csrfFetched = false;
api.interceptors.request.use(async (config) => {
    const method = config.method?.toUpperCase();

    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
        if (!csrfFetched) {
            try {
                await api.get(`/csrf-token`);
                csrfFetched = true;
            } catch (err) {
                console.error('Failed to fetch CSRF token:', err);
            }
        }
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;
